import { createSlice } from '@reduxjs/toolkit';
import { uuid } from '_helpers/common';
import { alertConstants } from '../_constants';

function alert(state = { errors: [] }, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        type: 'success',
        message: action.message,
        errors: [],
      };
    case alertConstants.ERROR:
      return {
        type: 'danger',
        message: action.message,
        errors: [],
      };
    case alertConstants.CLEAR:
      return { errors: [] };
    case alertConstants.FORM_ERROR:
      return {
        type: 'danger',
        message: action.message,
        errors: action.errors,
      };
    default:
      return state;
  }
}

/**
 * To mutate alert state.
 * @private
 * @param {StoreState} state Redux store state
 * @param {Action} action Reducer action
 * @param {AlertType} type type of alert. Example: danger, warning etc.
 * @returns New state for alert reducer
 */
const addAlert = (state, action, type) => {
  const newState = { ...state };
  const id = uuid();
  newState[id] = {
    id,
    type,
    message: action.payload,
  };
  return newState;
};

/**
 * @public
 * @name alertUiSlice
 * @description Declares a lice for redux store state.
 */
export const alertsUiSlice = createSlice({
  name: 'alerts',
  initialState: {},
  reducers: {
    addWarning: (state, action) => addAlert(state, action, 'warning'),
    addFailure: (state, action) => addAlert(state, action, 'danger'),
    addSuccess: (state, action) => addAlert(state, action, 'success'),
    clearAlert: (state, action) => {
      const newState = { ...state };
      delete newState[action.payload];
      return newState;
    },
    clearAllAlerts: () => {},
  },
});

/**
 * @public
 * @description Provide actions for alerts.
 */
export const alertActions = alertsUiSlice.actions;

export default alert;
